import config from "../api/config";
import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { IoCall, IoLockClosed } from "react-icons/io5";
import { encode } from "hex-encode-decode";

const VerifyCode = () => {
  const location = useLocation();
  const navigate = useHistory();
  const mode = new URLSearchParams(location.search).get("mode") || location.data || "verify";
  const [phoneNumber, setPhoneNumber] = useState(localStorage.getItem("name") || "");
  const [code, setCode] = useState("");
  const [codeSent, setCodeSent] = useState(mode !== "forgot" && Boolean(phoneNumber));
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const resendCode = async () => {
    setBusy(true);
    setError("");
    try {
      const phone = phoneNumber.replace(/\s+/g, "");
      await config.post(`/api/auth/v1/sendCode/${encodeURIComponent(phone)}`);
      setPhoneNumber(phone);
      localStorage.setItem("name", phone);
      setCodeSent(true);
    } catch {
      setError("Не удалось отправить код. Проверьте номер и повторите попытку.");
    } finally {
      setBusy(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!codeSent) return resendCode();
    setBusy(true);
    setError("");
    try {
      const { data } = await config.post(
        `/api/auth/v1/verify/${encodeURIComponent(code)}/${encodeURIComponent(phoneNumber)}`
      );
      const session = data.objectKoinot;
      if (!session?.accessToken) throw new Error("Missing verification token");
      if (mode === "forgot") {
        navigate.push("/newPassword", { resetToken: session.accessToken });
      } else {
        localStorage.setItem("auth", encode(session.accessToken));
        localStorage.setItem("login", encode("true"));
        localStorage.setItem("role", encode(JSON.stringify(session.roles)));
        localStorage.removeItem("password");
        window.location.assign("/");
      }
    } catch {
      setError("Неверный или просроченный код. Попробуйте ещё раз.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login_container" style={{ height: "100vh" }}>
      <div className="wrapper">
        <header>СМС Код</header>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <div className="input-area">
              {codeSent ? <>
                <input type="text" inputMode="numeric" autoComplete="one-time-code"
                  value={code} placeholder="СМС Код" required
                  onChange={(event) => setCode(event.target.value)} />
                <IoLockClosed className="icon" />
              </> : <>
                <input type="tel" autoComplete="tel" value={phoneNumber}
                  placeholder="Номер телефона" required
                  onChange={(event) => setPhoneNumber(event.target.value)} />
                <IoCall className="icon" />
              </>}
            </div>
            {error && <p role="alert" className="text-danger">{error}</p>}
            {codeSent && <button type="button" className="pass-txt my-3"
              disabled={busy} onClick={resendCode}>Не получили код?</button>}
          </div>
          <input type="submit" disabled={busy} value={busy ? "Подождите…" : codeSent ? "Подтвердить" : "Отправить код"} />
        </form>
        <Link to="/">Вернуться к входу</Link>
      </div>
    </div>
  );
};

export default VerifyCode;
